import { Component, Vue,Inject } from 'vue-property-decorator';
import appconst, {dicType} from './appconst'
import _ from "lodash"
import {RegexValidatorRuleType,RegexValidator} from "@/lib/regexValidator";
import tools from "@/lib/tools"
import { eventBus } from '@/lib/eventbus'
import moment from 'moment';
import {EventBusManager} from "@/lib/eventBusManager";
interface WINDOW_EMIT_DATA {
    id?: string,
    data?: any,
    extraData?:any,
}

//传入参数
export interface INPUT_WIN_PARAM extends WINDOW_EMIT_DATA{
    isOpen: boolean,
}

export function openWinCom(param: INPUT_WIN_PARAM, openEvent: string, updateEvent: string) {
    let emitData:WINDOW_EMIT_DATA = {
        extraData: param.extraData
    };

    if (!tools.isEmptyStr(param.id)) {
        var defaultData = {id: param.id, data: param.data}
        emitData = _.extend(defaultData,emitData);
    }

    if(tools.isEmptyStr(emitData.id) && tools.isEmptyStr(emitData.extraData)){
        return;
    }
    eventBus.$emit(openEvent,param.isOpen);
    eventBus.$emit(updateEvent, emitData);
};



export default class AbpBase extends Vue{
    eventBusMan:EventBusManager = new EventBusManager();

    dicTypeEnum = dicType;//字典类型enum

    $style: any;
        /**
     * 显示加载条
     */
    spinning = true;
    /**
     * 加载条持续时间
     */
    delayTime = 500;

    /**
     * 获取当前主题
     */
    // get curTheme(){
    //     return this.$store.state.
    // }

    L(value:string,source?:string,...argus:string[]):string{
        if(source){
            return window.abp.localization.localize(value,source,argus);
        }else{
            return window.abp.localization.localize(value,appconst.localization.defaultLocalizationSourceName,argus);
        }

    }
    hasPermission(permissionName:string){
        return window.abp.auth.hasPermission(permissionName);
    }
    hasAnyOfPermissions(...argus:string[]){
        return window.abp.auth.hasAnyOfPermissions(...argus);
    }
    hasAllOfPermissions(...argus:string[]){
        return window.abp.auth.hasAllOfPermissions(...argus);
    }

    moment(){
        return moment();
    }


    private getRegexValidatorInstance(){
        return new RegexValidator();
    }


     /**
     * 获取正则验证规则字符串
     * @param ruleName 规则名
     */
    getRegValidatePattern(ruleName:RegexValidatorRuleType){
        let regInstance = this.getRegexValidatorInstance()
        let validateFunc = regInstance[ruleName];
        let validateObj;
        let ret = null;
        // debugger
        if(typeof(validateFunc)==="function"){
            validateObj = validateFunc();
            ret = validateObj.pattern;
        }
        return ret;
    }

    /**
     * 获取正则验证规则说明信息
     * @param ruleName 规则名
     */
    getRegValidateMessage(ruleName:RegexValidatorRuleType){
        let regInstance = this.getRegexValidatorInstance()
        let validateFunc = regInstance[ruleName];
        let validateObj;
        let ret = null;
        if(typeof(validateFunc)==="function"){
            validateObj = validateFunc();
            ret = validateObj.message;
        }
        return ret;
    }

    /**
     * 打开弹出窗
     * @param param 弹出窗参数
     * @param openEvent 打开事件
     * @param updateEvent 更新事件
     */
    openModal(param:INPUT_WIN_PARAM,openEvent:string,updateEvent:string){
        openWinCom(param,openEvent,updateEvent);
    }


    clearEventBusBind(){
        this.eventBusMan.clear();
    }

    //切换路由
    switchRouting(routerName: string = '', params: any = undefined) {
        let repParam = {};
        // _.each(params,(val,ind)=>{
        //     if(val){
        //         repParam[ind] = val;
        //     }
        // })
        this.$router.push({name: routerName, params: params});
    }
}
